// extracted by mini-css-extract-plugin
export default {"expandedSearch":"expanded-search_tsx_expandedSearch__uqZtO","expandedSearchCheckbox":"expanded-search_tsx_expandedSearchCheckbox__CLRzu"};